var _ = (I, w, x) => new Promise((q, g) => {
  var f = (d) => {
    try {
      N(x.next(d));
    } catch (k) {
      g(k);
    }
  }, h = (d) => {
    try {
      N(x.throw(d));
    } catch (k) {
      g(k);
    }
  }, N = (d) => d.done ? q(d.value) : Promise.resolve(d.value).then(f, h);
  N((x = x.apply(I, w)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { defineComponent as ne, useTemplateRef as ue, computed as F, openBlock as y, createElementBlock as v, createElementVNode as i, createVNode as n, withCtx as p, Fragment as H, renderList as R, createCommentVNode as J, createTextVNode as m, createBlock as re } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as ie } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as u, unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import pe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import de from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import ye from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import { toDisplayString as A } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import c from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import ve from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import E from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
const fe = { key: 0 }, me = {
  key: 0,
  style: { "margin-top": "20px" }
}, ce = { style: { width: "150px", "font-size": "14px" } }, ge = { style: { display: "flex", "align-items": "center" } }, he = { key: 1 }, Te = { style: { display: "flex", "align-items": "center" } }, be = {
  key: 0,
  style: { "font-size": "12px", color: "#f5222d", "margin-top": "5px" }
}, xe = { style: { "font-size": "12px", color: "#999", "margin-top": "20px", padding: "10px", background: "#f5f5f5", "border-radius": "4px" } }, Ne = { style: { width: "100%", display: "flex", "justify-content": "right", "margin-top": "20px" } }, Oe = /* @__PURE__ */ ne({
  __name: "houseTypeEditDialog.ce",
  emits: ["submit"],
  setup(I, { expose: w, emit: x }) {
    const q = ue("houseTypeEditDialogContainer"), g = ie(), f = u(!1), h = u(!1), N = u(!1), d = u(""), k = u(""), O = u(""), U = u(""), B = u(""), T = u(0), S = u(""), z = u([]), b = u([]), s = u([]), D = F(() => U.value === "合同"), G = F(() => s.value.reduce((t, e) => t + (Number(e.quantity) || 0), 0)), Q = (t, e) => {
      const a = Number(e);
      !isNaN(a) && a >= 1 ? s.value[t].quantity = a : e === "" && (s.value[t].quantity = 1);
    }, K = () => _(this, null, function* () {
      try {
        h.value = !0;
        const { selfAxios: t } = yield import("@oppein/op-utils"), e = yield t.get("/designordercenter/productionOrder/getHouseTypeList", {
          params: { applyCode: B.value }
        });
        e.data && e.data.status && (z.value = (e.data.data || []).map((a) => ({
          label: a.houseTypeName || a.houseType || a.name,
          value: a.houseType || a.code || a.name
        })));
      } catch (t) {
        console.error("获取户型列表失败:", t);
      } finally {
        h.value = !1;
      }
    }), $ = () => {
      if (S.value)
        try {
          const t = JSON.parse(S.value);
          Array.isArray(t) && (s.value = t.map((e) => ({
            houseType: e.houseType || "",
            quantity: Number(e.quantity) || 1
          })), b.value = t.map((e) => e.houseType || ""));
        } catch (t) {
          console.error("解析houseTypeNumberJson失败:", t);
        }
    }, P = () => {
      s.value = b.value.map((t) => ({
        houseType: t,
        quantity: b.value.length === 1 ? T.value : 1
      }));
    }, V = (t) => {
      s.value[t].quantity++;
    }, L = (t) => {
      s.value[t].quantity > 1 && s.value[t].quantity--;
    }, W = () => {
      s.value.push({
        houseType: "",
        quantity: 1
      });
    }, X = (t) => {
      s.value.splice(t, 1);
    }, Y = () => G.value !== T.value ? (g.error(`所有户型的套数之和必须等于服务单的取号总套数(${T.value})`), !1) : !0, C = u(""), Z = () => {
      for (const t of s.value) {
        if (!t.houseType || !t.houseType.trim())
          return C.value = "请输入户型！", !1;
        if (typeof t.quantity != "number" || t.quantity < 1)
          return C.value = "请输入套数！", !1;
      }
      return !0;
    }, ee = () => {
    }, te = () => _(this, null, function* () {
      var t;
      try {
        h.value = !0;
        const { selfAxios: e } = yield import("@oppein/op-utils"), a = s.value.map((j) => ({
          houseType: j.houseType,
          quantity: Number(j.quantity)
        }));
        a.length === 1 && a[0].houseType && (a[0].quantity = T.value);
        const r = JSON.stringify(a), l = yield e.post("/production-order/engineering/salesEngineeringOrderServiceOrder/updateLocalByHouseTypeNumberJson", {
          customerId: d.value,
          houseTypeNumberJson: r,
          signApplyId: k.value,
          id: O.value
        });
        return l.data && l.data.status ? (g.success("保存成功"), !0) : (g.error(((t = l.data) == null ? void 0 : t.message) || "保存失败"), !1);
      } catch (e) {
        return console.error("保存服务单失败:", e), g.error("保存失败"), !1;
      } finally {
        h.value = !1;
      }
    }), ae = () => _(this, null, function* () {
      Z() && Y() && (N.value ? (yield te()) && (M(s.value), f.value = !1) : (M(s.value), f.value = !1), C.value = "");
    }), se = () => {
      f.value = !1;
    }, M = (t) => {
      le("submit", t);
    };
    function oe(t) {
      return _(this, null, function* () {
        N.value = t.isNeedSave || !1, d.value = t.customerId || "", S.value = t.houseTypeNumberJson || "", k.value = t.signApplyId || "", O.value = t.id || "", U.value = t.businessType || "", B.value = t.applyCode || "", T.value = Number(t.quantity) || 1, s.value = [], b.value = [], z.value = [], D.value ? (yield K(), $()) : ($(), s.value.length === 0 && (s.value = [{ houseType: "", quantity: T.value }])), f.value = !0;
      });
    }
    const le = x;
    return w({ open: oe }), (t, e) => (y(), v(H, null, [
      i("div", {
        ref_key: "houseTypeEditDialogContainer",
        ref: q
      }, null, 512),
      n(o(ve), {
        bordered: "",
        show: f.value,
        "onUpdate:show": e[1] || (e[1] = (a) => f.value = a),
        "mask-closable": !1,
        to: q.value || "body",
        title: "编辑户型"
      }, {
        default: p(() => [
          n(o(pe), { show: h.value }, {
            default: p(() => [
              n(o(de), {
                style: { width: "655px" },
                bordered: !1,
                role: "dialog"
              }, {
                default: p(() => [
                  D.value ? (y(), v("div", fe, [
                    e[5] || (e[5] = i("div", { style: { "font-size": "14px", "margin-bottom": "10px" } }, [
                      i("span", null, "选择户型")
                    ], -1)),
                    n(o(ye), {
                      value: b.value,
                      "onUpdate:value": [
                        e[0] || (e[0] = (a) => b.value = a),
                        P
                      ],
                      options: z.value,
                      multiple: "",
                      clearable: "",
                      placeholder: "请选择户型",
                      filterable: "",
                      style: { width: "100%" }
                    }, null, 8, ["value", "options"]),
                    b.value.length > 0 ? (y(), v("div", me, [
                      (y(!0), v(H, null, R(s.value, (a, r) => (y(), v("div", {
                        key: r,
                        style: { display: "flex", "align-items": "center", "margin-bottom": "15px" }
                      }, [
                        i("span", ce, A(a.houseType), 1),
                        e[4] || (e[4] = i("span", { style: { "font-size": "14px", "margin-right": "10px" } }, "数量", -1)),
                        i("div", ge, [
                          n(o(c), {
                            size: "small",
                            onClick: (l) => L(r),
                            disabled: a.quantity <= 1
                          }, {
                            default: p(() => e[2] || (e[2] = [
                              m(" - ", -1)
                            ])),
                            _: 2,
                            __: [2]
                          }, 1032, ["onClick", "disabled"]),
                          n(o(E), {
                            value: String(a.quantity),
                            style: { width: "80px", "text-align": "center" },
                            "onUpdate:value": (l) => Q(r, l)
                          }, null, 8, ["value", "onUpdate:value"]),
                          n(o(c), {
                            size: "small",
                            onClick: (l) => V(r)
                          }, {
                            default: p(() => e[3] || (e[3] = [
                              m("+", -1)
                            ])),
                            _: 2,
                            __: [3]
                          }, 1032, ["onClick"])
                        ])
                      ]))), 128))
                    ])) : J("", !0)
                  ])) : (y(), v("div", he, [
                    (y(!0), v(H, null, R(s.value, (a, r) => (y(), v("div", {
                      key: r,
                      style: { display: "flex", "align-items": "center", "margin-bottom": "15px" }
                    }, [
                      e[9] || (e[9] = i("span", { style: { "font-size": "14px", "margin-right": "10px" } }, "户型", -1)),
                      n(o(E), {
                        value: a.houseType,
                        "onUpdate:value": [(l) => a.houseType = l, ee],
                        placeholder: "请输入户型",
                        style: { width: "200px" }
                      }, null, 8, ["value", "onUpdate:value"]),
                      e[10] || (e[10] = i("span", { style: { "font-size": "14px", "margin-left": "10px", "margin-right": "10px" } }, "数量", -1)),
                      i("div", Te, [
                        n(o(c), {
                          size: "small",
                          onClick: (l) => L(r),
                          disabled: a.quantity <= 1
                        }, {
                          default: p(() => e[6] || (e[6] = [
                            m(" - ", -1)
                          ])),
                          _: 2,
                          __: [6]
                        }, 1032, ["onClick", "disabled"]),
                        n(o(E), {
                          value: String(a.quantity),
                          style: { width: "80px", "text-align": "center" },
                          "onUpdate:value": (l) => Q(r, l)
                        }, null, 8, ["value", "onUpdate:value"]),
                        n(o(c), {
                          size: "small",
                          onClick: (l) => V(r)
                        }, {
                          default: p(() => e[7] || (e[7] = [
                            m("+", -1)
                          ])),
                          _: 2,
                          __: [7]
                        }, 1032, ["onClick"])
                      ]),
                      s.value.length > 1 ? (y(), re(o(c), {
                        key: 0,
                        size: "small",
                        type: "error",
                        style: { "margin-left": "10px" },
                        onClick: (l) => X(r)
                      }, {
                        default: p(() => e[8] || (e[8] = [
                          m(" 删除 ", -1)
                        ])),
                        _: 2,
                        __: [8]
                      }, 1032, ["onClick"])) : J("", !0)
                    ]))), 128)),
                    C.value ? (y(), v("div", be, A(C.value), 1)) : J("", !0),
                    n(o(c), {
                      type: "primary",
                      size: "small",
                      style: { "margin-top": "10px" },
                      onClick: W
                    }, {
                      default: p(() => e[11] || (e[11] = [
                        m(" + 新增户型 ", -1)
                      ])),
                      _: 1,
                      __: [11]
                    })
                  ])),
                  i("div", xe, " 提示：所有户型的套数之和必须等于服务单的取号总套数(" + A(T.value) + ") ", 1),
                  i("div", Ne, [
                    n(o(c), {
                      onClick: se,
                      style: { "border-radius": "5px" }
                    }, {
                      default: p(() => e[12] || (e[12] = [
                        m("取消", -1)
                      ])),
                      _: 1,
                      __: [12]
                    }),
                    n(o(c), {
                      onClick: ae,
                      style: { "margin-left": "30px", "background-color": "#fc9153 !important", "border-color": "#fc9153 !important", "--n-button-color": "#fff !important", "border-radius": "5px" },
                      type: "primary"
                    }, {
                      default: p(() => e[13] || (e[13] = [
                        m(" 保存 ", -1)
                      ])),
                      _: 1,
                      __: [13]
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  Oe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/house-type-edit-dialog/houseTypeEditDialog.ce.vue2.js
// module id = 1254
// module chunks = 41